module.exports = '<svg width="63" height="32" viewBox="0 0 63 32"><path d="M19.714 30.825V19.722H43.38v11.103c0 1.171.809 1.526 1.728.793l17.264-14.294c.915-.734.738-1.913-.174-2.647L45.103.383c-.911-.734-1.724-.379-1.724.793v10.657H19.713V1.176c0-1.171-.895-1.526-1.81-.793L.619 14.677c-.915.738-.765 1.913.146 2.651l17.138 14.294c.911.73 1.81.375 1.81-.797z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/expand-horizontally-1.js
// module id = 1128
// module chunks = 14